import { IFilterDTO } from './../../api/plyca-dtos';
import { Directive, OnInit } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { PaginationDTO } from '../../api/PaginationModel';
import { IObjectDTO } from '../../api/plyca-dtos';

import { BaseFormComponent } from './baseForm.component';
import { FormConfig } from '../../components/forms/form.objects';


export interface TModel<T extends IObjectDTO<any>> {
  filter: IFilterDTO;
  tableModel: Array<T>;
  ui?: any;
}



@Directive()
export abstract class FilteredBaseFormComponent<T extends IObjectDTO<any>>
  extends BaseFormComponent<T, TModel<T>> implements OnInit {



  autosearch = false;

  abstract updateTableModel(result: PaginationDTO<T>): TModel<T>;
  abstract initModel(): TModel<T>;


  ngOnInit(): void {
    this.waitService.startWaiting();
    // inicializacion de modelo y formulario
    this.model = this.initModel();
    let initObservable: Observable<any>;
    if (this.autosearch) {
      initObservable = this.searchOb()
    } else {
      initObservable = of({});
    }
    this.subscribeObserver(initObservable
      .pipe(
        switchMap(() => this.createFormConfig()),
        switchMap((form: FormConfig) => this.configureFormConfig(form)),
        tap((form: FormConfig) => (this.formConfig = form)),
        finalize(() => {
          // cargar datos cabecera
          this.initHeaderInfo();
          this.initHeaderActions();
          this.componentInitialized = true;
          this.cancelInitWait();
        }),
        catchError((error: any) => {
          console.log('manageFormException 2', error);

          this.manageActionError(error);

          return throwError(error);
        })
      ), {
      error: (error: any) => this.waitService.cancelWaiting(),
      complete: () => this.loaded = true
    });
  }

  public searchOb(): Observable<any> {

    return this.plycaService.query<T>(
      this.getServiceURL(), this.getParams()
    ).pipe(
      tap((result: PaginationDTO<T>) => {
        if (result?.content) {
          this.model = this.updateTableModel(result)
        } else {
          this.model.tableModel = [];
          this.model = this.updateTableModel(result)
        }
      })
    );
  }


  public search(): void {
    this.waitService.startWaiting();

    this.subscribe(this.searchOb().pipe(finalize(() => { this.waitService.cancelWaiting() })));
  }

  getParams() {
    let params = this.filterToParam();

    return params as { [param: string]: string | string[] };
  }
  filterToParam(): IFilterDTO {
    return this.model.filter;
  }
  clearFilter(): void {

    Object.keys(this.model.filter)
      .forEach(key => delete this.model.filter[key]);


  }
  getObjectIdentifier() {
    throw new Error('Method not implemented.');
  }
  dtoToModel(dto: T): Observable<TModel<T>> {
    throw new Error('Method not implemented.');
  }
  modelToDTO(model: TModel<T>): T {
    throw new Error('Method not implemented.');
  }





}
